import React, { useRef, useState } from "react";
import TextEditor from "../../../components/TextEditor";
import FileUpload from "../../../components/FileUpload";
import * as api from "../../../services/apiService";
import Toast from "react-bootstrap/Toast";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import './ProblemCreatePage.scss';

function ProblemCreatePage() {
  const [title, setTitle] = useState("");
  const [text, setText] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [file, setFile] = useState(null);

  function handleTitleChange(e) {
    if (e.target.value.length <= 100) {
      setTitle(e.target.value);
    }
  }

  function handleTextChange(content) {
    setText(content);
  }

  function handleFileChange(arg) {
    if (arg) {
      setFile(arg);
    }
  }

  async function handleSave() {
    let imageId = null;
    if(file) {
      const imageResponse = await api.uploadImage(file);
      if(imageResponse.status === 200){
        const imageData = await imageResponse.text();
        const imageMessage = JSON.parse(imageData);
        imageId = imageMessage.id;
      } else {
        setToastMessage("Imginea nu a putut fi salvata!");
        return;
      }
    }

    const body = { 
      title: title, 
      text: text,
      imageId: imageId,
    };
    const response = await api.addComplaint(body);

    if (title === '' || text === '') {
      setToastMessage("Trebuie completate toate casuţele!");
    } else if (response.status === 200) {
      setToastMessage("Problema a fost adăugată cu succes!");
      setTitle("");
      setText("");
      if (quillRef.current) {
        quillRef.current.getEditor().setText("");
      }
    } else if (response.status === 400) {
      const data = await response.text();
      const message = JSON.parse(data);
      console.log(message);
      setToastMessage(message);
    } else {
      setToastMessage("A apărut o eroare. Vă rugăm să încercați din nou.");
    }

    setShowToast(true);
  }

  const quillRef = useRef();

  return (
    <main className="container py-4">
      <Form className="problem-create-form text-white">
        <Form.Group className="form-group" controlId="formTitle">
          <Form.Label className="form-label">Titlul Problemei:</Form.Label>
          <Form.Control
            type="text"
            value={title}
            onChange={handleTitleChange}
            maxLength={100}
            placeholder="Introduceți până la 100 de caractere..."
          />
          <Form.Text className={`form-text ${title.length === 100 ? "text-danger" : "text-muted"}`}>
            {title.length} / 100
          </Form.Text>
        </Form.Group>

        <Form.Group className="form-group" controlId="formFileUpload">
          <Form.Label className="form-label">Adaugă imagini:</Form.Label>
          <FileUpload onFileChanged={handleFileChange} />
        </Form.Group>

        <Form.Group className="form-group" controlId="formDescription">
          <Form.Label className="form-label">Descrierea Problemei:</Form.Label>
            <TextEditor onTextChange={handleTextChange} ref={quillRef} />
        </Form.Group>

        <Button
          onClick={handleSave}
          variant="warning"
          className="submit-button"
        >
          Adaugă
        </Button>
      </Form>

      <div className="toast-container">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={5000}
          autohide
          className="toast"
          animation={false}
        >
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </div>
    </main>
  );
}

export default ProblemCreatePage;
